<template>
    <div class="PartnerWelcome">
        <h1 class="text-center">Látogatói regisztráció</h1>
        <VisitorRegisterAction/>
    </div>
</template>

<script>
    import VisitorRegisterAction from './VisitorRegisterAction';

    export default {
        components: {VisitorRegisterAction},
        beforeRouteEnter(to, from, next) {
            if (window.user) {
                next('/')
            } else {
                next();
            }
        }
    };
</script>
